// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ahHl","content":"styles_content__2ZDQZ"};